<template>
  <main-template>
    <v-row>
      <v-col cols="12">
        <v-col cols="12" class="pt-3 px-0">
          <div class="d-flex justify-content-end">
            <v-text-field
              v-model="search"
              class="search-input"
              append-icon="mdi-magnify"
              label="Pesquisar..."
              solo
              autofocus
              dense
              single-line
              hide-details
            />
          </div>
        </v-col>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="avisos"
          :loading="carregandoAvisos"
          :items-per-page="10"
          hide-default-footer
          :custom-filter="dataTableFilter"
          :search="search"
          no-data-text="Não foram encontrádos avisos para você."
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr color="primary" v-for="(aviso, index) in items" :key="aviso.id">
                <td>{{ aviso.id }}</td>
                <td>{{ aviso.parent.titulo || "- - -" }}</td>
                <td>{{ aviso.parent.contexto || "- - -" }}</td>
                <td class="text-capitalize" :key="index">
                  <v-chip
                    class="ma-2"
                    style="width: 80px; justify-content: center"
                    color="primary"
                    outlined
                    label
                    small
                  >
                    {{ aviso.parent.tipo || "- - -" }}
                  </v-chip>
                </td>
                <td>
                  <v-tooltip color="primary" bottom offset-x>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => verAviso(aviso)"
                      >
                        <span class="material-icons"> visibility </span>
                      </v-btn>
                    </template>
                    <span>Visualizar aviso</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          :pageNumber="pageNumber"
          @changeActionResponse="loadData"
          :search="search"
        ></e-paginate>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog v-model="dialog" width="374" @click:outside="fecharAviso">
        <v-card v-if="aviso" class="mx-auto" max-width="374">
          <v-sheet
            v-if="carregandoImagem"
            :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
          >
            <v-skeleton-loader class="mx-auto" type="image" height="200px"></v-skeleton-loader>
          </v-sheet>

          <v-img v-else-if="url_image_aviso" :src="url_image_aviso" height="200px"></v-img>

          <v-card-title> {{ aviso.titulo || "- - -" }} </v-card-title>

          <v-card-subtitle> {{ aviso.contexto || "- - -" }} </v-card-subtitle>

          <v-card-actions>
            <v-btn @click="fecharAviso" color="orange lighten-2" text> Fechar </v-btn>

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      dataTableFilter,
      avisos: [],
      carregandoAvisos: false,
      search: "",
      pageNumber: 0,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      item: {
        aluno: "nomecompleto",
        turma: "descricao",
        franquia: "descricao",
      },
      tipos: ["alunos", "turmas", "configuracoes"],
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Titulo", value: "titulo" },
          { text: "Contexto", value: "contexto" },
          { text: "Tipo", value: "tipo" },
          {
            text: "Ações",
            value: "actions",
            sortable: false,
            width: "200px",
          },
        ],
      },
      aviso: null,
      url_image_aviso: "",
      carregandoImagem: false,
      dialog: false,
    };
  },
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  computed: {
    ...mapGetters("Auth", ["senhaFraca", "user"]),
    id() {
      return this.aviso.id;
    },
  },
  watch: {
    async search(val) {
      if (val.length > 2) {
        await this.loadData(0, val);
      }
      if (!val) {
        await this.loadData(0);
      }
    },
  },
  methods: {
    async loadData(pageNumber, query = null) {
      this.$loaderService.open("Enviando avisos...");
      try {
        const response = await this.$services.avisosService.portalAluno(pageNumber, query);
        this.paginate = response;
        this.avisos = response.data;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async verAviso(aviso) {
      this.aviso = aviso.parent || aviso;
      this.url_image_aviso = "";
      this.dialog = true;

      const origem = [aviso, this.aviso].find((registro) => registro.imagem);
      if (!origem) return;

      this.carregandoImagem = true;
      try {
        this.url_image_aviso = await this.$services.imageService.downloadImage(
          `notifiq/avisos/download-image/${origem.id}`
        );
      } catch (error) {
        this.url_image_aviso = "";
      }
      this.carregandoImagem = false;
    },
    fecharAviso() {
      this.dialog = false;
      this.aviso = null;
      this.url_image_aviso = "";
      this.carregandoImagem = false;
    },
  },
  mounted() {
    this.loadData(this.pageNumber);
  },
};
</script>

<style></style>
